import type { Subscription } from "api";
import type { LoadStatus } from "hooks/useProfile";
import type { GotoTarget } from "./dashboard.model";
import { activeProducts } from "./dashboard.model";
import { DashboardCard } from "./DashboardCard";

type ProductsCardProps = {
  subscriptions: Subscription[];
  status: LoadStatus;
  onGoto: (target: GotoTarget) => void;
};

/**
 * The products this company actually has. Each opens its own page on the site,
 * which is where a product is documented — the cabinet has no page of its own
 * for it.
 */
export const ProductsCard = ({ subscriptions, status, onGoto }: ProductsCardProps) => {
  const products = activeProducts(subscriptions);

  return (
    <DashboardCard
      wide
      title="Your products"
      sub="What your subscriptions give you access to"
      action={{ label: "Subscriptions", onClick: () => onGoto({ pane: "myqubics" }) }}
      status={status}
      isEmpty={products.length === 0}
      empty="No products are connected yet."
      failure="Could not load your products. Please refresh the page."
    >
      <div className="dsh__prod">
        {products.map((product) => (
          <a className="dsh__p" key={product.id} href={product.href}>
            <img className="pccube dsh__p-c" src={product.cube} alt="" width={30} height={30} />
            <span className="dsh__p-t">
              <b>{product.name}</b>
              <em>{product.blurb}</em>
            </span>
          </a>
        ))}
      </div>
    </DashboardCard>
  );
};
